"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.userActions = exports.userHasPermission = exports.ADMIN_ROLES = exports.ROLES = exports.page_icon = exports.Permission = exports.UserType = exports.UserRoles = void 0;
var UserRoles;
(function (UserRoles) {
    // Can log (Verified in LoginActions)
    UserRoles["ADMIN"] = "admin";
    UserRoles["SUPERADMIN"] = "superadmin";
    UserRoles["INSIDE_SERVICE"] = "inside-service";
    UserRoles["P_AND_O"] = "P&O";
    UserRoles["ICT"] = "ICT";
    UserRoles["SUPER_CONSENTER"] = "super-consenter";
    UserRoles["CONTROLLER"] = "controller";
    UserRoles["ROOFER"] = "roofer";
    UserRoles["MECHANIC"] = "mechanic";
    UserRoles["DEFAULT"] = "";
})(UserRoles = exports.UserRoles || (exports.UserRoles = {}));
var UserType;
(function (UserType) {
    UserType["APP"] = "app";
    UserType["PORTAL"] = "portal";
})(UserType = exports.UserType || (exports.UserType = {}));
var Permission;
(function (Permission) {
    // Pages
    Permission["PAGE_REALTIME"] = "Realtime";
    Permission["PAGE_HOURS"] = "Urencontrole";
    Permission["PAGE_REPORTS"] = "Rapporten";
    Permission["PAGE_REPORT_HOURS"] = "Urenrapport";
    Permission["PAGE_REPORT_TIMELINES"] = "Gebruikerstijdlijn";
    Permission["PAGE_CLOSING_DAY_REPORT"] = "Overzicht van Sluit de Dag notities";
    Permission["PAGE_LOCALITIES"] = "Locaties";
    Permission["PAGE_PORTAL_USERS"] = "Gebruikers";
    Permission["PAGE_APP_USERS"] = "App Gebruikers";
    Permission["PAGE_GPS_PROPOSAL"] = "GPS-voorstel";
    Permission["PAGE_GPS_LOSS_USERS"] = "Zonder gps";
    Permission["PAGE_SETTINGS"] = "Settings";
    Permission["PAGE_HOUR_TYPES"] = "Uursoorten";
    // Actions
    Permission["LOGOUT"] = "Uitloggen";
    Permission["SAVE_HOURS"] = "Keur Goed";
    Permission["IMPORT_ADDRESES"] = "Importeer Adressen";
})(Permission = exports.Permission || (exports.Permission = {}));
var PAGE_ICON = (_a = {},
    _a[Permission.PAGE_REALTIME] = 'map',
    _a[Permission.PAGE_HOURS] = 'date_range',
    _a[Permission.PAGE_REPORTS] = 'description',
    _a[Permission.PAGE_LOCALITIES] = 'location_on',
    _a[Permission.PAGE_PORTAL_USERS] = 'contacts',
    _a[Permission.PAGE_SETTINGS] = 'settings',
    _a[Permission.PAGE_APP_USERS] = 'apps',
    _a[Permission.PAGE_GPS_PROPOSAL] = 'travel_explore',
    _a[Permission.PAGE_GPS_LOSS_USERS] = 'location_off',
    _a[Permission.IMPORT_ADDRESES] = 'cloud_upload',
    _a[Permission.PAGE_HOUR_TYPES] = 'rule',
    _a[Permission.LOGOUT] = 'exit_to_app',
    _a);
var page_icon = function (page) {
    return PAGE_ICON[page] || 'default-icon';
};
exports.page_icon = page_icon;
exports.ROLES = (_b = {},
    _b[UserType.APP] = (_c = {},
        _c[UserRoles.MECHANIC] = 'Monteur',
        _c[UserRoles.ROOFER] = 'Dakdekker',
        _c),
    _b[UserType.PORTAL] = (_d = {},
        _d[UserRoles.INSIDE_SERVICE] = 'Binnendienst',
        _d[UserRoles.ICT] = 'ICT',
        _d[UserRoles.P_AND_O] = 'P&O',
        _d[UserRoles.SUPER_CONSENTER] = 'Fiateur',
        _d[UserRoles.CONTROLLER] = 'Controleur',
        _d),
    _b);
exports.ADMIN_ROLES = (_e = {},
    _e[UserType.PORTAL] = (_f = {},
        _f[UserRoles.ADMIN] = 'Admin',
        _f),
    _e);
var managerPermissions = [
    Permission.PAGE_HOURS,
    Permission.PAGE_PORTAL_USERS,
    Permission.PAGE_APP_USERS,
    Permission.PAGE_GPS_LOSS_USERS,
    Permission.PAGE_REPORTS,
    Permission.PAGE_REPORT_HOURS,
    Permission.PAGE_REPORT_TIMELINES,
    Permission.PAGE_LOCALITIES,
    Permission.PAGE_REALTIME,
    Permission.PAGE_SETTINGS,
    Permission.PAGE_CLOSING_DAY_REPORT
];
var permissions = (_g = {},
    _g[UserRoles.SUPER_CONSENTER] = [
        Permission.PAGE_HOURS,
        Permission.PAGE_APP_USERS,
        Permission.PAGE_GPS_LOSS_USERS,
        Permission.PAGE_REPORTS,
        Permission.PAGE_REPORT_HOURS,
        Permission.PAGE_REPORT_TIMELINES,
        Permission.PAGE_LOCALITIES,
        Permission.PAGE_REALTIME,
        Permission.SAVE_HOURS,
        Permission.PAGE_CLOSING_DAY_REPORT
    ],
    _g[UserRoles.CONTROLLER] = [
        Permission.PAGE_HOURS,
        Permission.PAGE_APP_USERS,
        Permission.PAGE_GPS_LOSS_USERS,
        Permission.PAGE_REPORTS,
        Permission.PAGE_REPORT_HOURS,
        Permission.PAGE_REPORT_TIMELINES,
        Permission.PAGE_LOCALITIES,
        Permission.PAGE_REALTIME,
        Permission.PAGE_CLOSING_DAY_REPORT
    ],
    _g[UserRoles.INSIDE_SERVICE] = [Permission.PAGE_REALTIME],
    _g[UserRoles.P_AND_O] = managerPermissions,
    _g[UserRoles.ICT] = managerPermissions,
    // Managing which hour types a company may book on is an admin job (DMHA-1036):
    // it changes what every app and portal user of that company gets to pick from.
    _g[UserRoles.ADMIN] = __spreadArray(__spreadArray([], managerPermissions, true), [Permission.SAVE_HOURS, Permission.IMPORT_ADDRESES, Permission.PAGE_HOUR_TYPES], false),
    _g[UserRoles.SUPERADMIN] = __spreadArray(__spreadArray([], managerPermissions, true), [Permission.SAVE_HOURS, Permission.IMPORT_ADDRESES, Permission.PAGE_HOUR_TYPES], false),
    _g);
var userHasPermission = function (user, permission) {
    return user && permissions[user.role] && !!permissions[user.role].find(function (p) { return p === permission; });
};
exports.userHasPermission = userHasPermission;
var userActions = function (user) {
    var userPermission = permissions[user.role] || [];
    return userPermission;
};
exports.userActions = userActions;
